import type { FC, ReactNode } from 'react'

import { useEffect, useState } from 'react'
import { ArrowLeft } from 'lucide-react'
import { cn } from '@/lib/utils'

// a signup button pinned to the bottom of phones, hidden over the hero, the form and the footer
const MobileTrialBar: FC = (): ReactNode => {
    const [scrolled, setScrolled] = useState(false)
    const [covered, setCovered] = useState(false)

    useEffect(() => {
        const onScroll = (): void => setScrolled(window.scrollY > window.innerHeight * 0.7)

        onScroll()
        window.addEventListener('scroll', onScroll, { passive: true })

        return () => window.removeEventListener('scroll', onScroll)
    }, [])

    useEffect(() => {
        const targets = ['trial', 'site-footer']
            .map((id) => document.getElementById(id))
            .filter((element): element is HTMLElement => element !== null)

        if (targets.length === 0 || !('IntersectionObserver' in window)) return

        const visible = new Set<Element>()
        const observer = new IntersectionObserver((entries) => {
            for (const entry of entries) {
                if (entry.isIntersecting) visible.add(entry.target)
                else visible.delete(entry.target)
            }

            setCovered(visible.size > 0)
        }, { threshold: 0.05 })

        for (const target of targets) observer.observe(target)

        return () => observer.disconnect()
    }, [])

    const show = scrolled && !covered

    return (
        <div
            aria-hidden={!show}
            className={cn(
                'fixed inset-x-0 bottom-0 z-40 border-t border-border bg-background/90 px-4 pt-3 pb-[max(0.75rem,env(safe-area-inset-bottom))] backdrop-blur-lg transition-transform duration-300 md:hidden',
                show ? 'translate-y-0' : 'translate-y-full'
            )}
        >
            <a
                href='#trial'
                tabIndex={show ? 0 : -1}
                className='flex min-h-12 w-full items-center justify-center gap-2 rounded-full bg-primary px-6 text-base font-semibold text-primary-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring'
            >
                הרשמה לשיעור ניסיון
                <ArrowLeft aria-hidden='true' className='size-5' />
            </a>
        </div>
    )
}

export default MobileTrialBar
